import * as yup from 'yup'

export const loginValidationSchema = yup.object().shape({
  email: yup.string().required('This field is required'),
  password: yup.string().required('This field is required'),
  rememberMe: yup.boolean(),
})

export type LoginSchemaType = {
  email: string
  password: string
  rememberMe: boolean
}

export const loginInitialValues = {
  email: '',
  password: '',
  rememberMe: false,
}
